import { useEffect, useState } from "react";
import { toast } from "react-toastify";

import {
  useExportDatasetMutation,
  useGetOperationStatus
} from "@/api/dataset/useDatasetAPI";
import { ExportDatasetFileType, OperationStatusType } from "@/types/dataset";

import useToast, { EToastType } from "../ui/useToast";

export const useDownloadDataset = () => {
  const { showToast } = useToast();
  const [operationId, setOperationId] = useState<string>("");

  const { mutate: exportDataset } = useExportDatasetMutation({
    onMutate: () => {
      showToast({
        id: "download-dataset",
        type: EToastType.LOADING,
        message: "Please wait while you dataset is being downloaded...",
        className: "!bg-green-50 !border-shamrock-green"
      });
    },
    onError: (error) => {
      showToast({
        type: EToastType.ERROR,
        message:
          (error.message?.message as string) || "Failed to download dataset.",
        autoClose: 2000
      });
    },
    onSuccess: (data) => {
      setOperationId(data.operation_id);
    }
  });

  const { data } = useGetOperationStatus(operationId, {
    enabled: !!operationId,
    refetchInterval: 5000,
    refetchIntervalInBackground: true
  });

  const handleDownloadDataset = (
    fileType: ExportDatasetFileType,
    id?: string
  ) => {
    if (!id) {
      showToast({
        id: "download-dataset-error",
        type: EToastType.ERROR,
        message: "Dataset id not found."
      });
      return;
    }
    exportDataset({ id, fileType });
  };

  useEffect(() => {
    if (data?.status === OperationStatusType.SUCCESS) {
      window.open(data.export_url, "_blank", "noopener,noreferrer");
    }

    if (
      data?.status === OperationStatusType.FAILED ||
      data?.status === OperationStatusType.SUCCESS
    ) {
      setOperationId("");
      toast.dismiss();
    }
  }, [data]);

  return {
    handleDownloadDataset
  };
};
